/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{useCallback as r}from"react";import{ErrorBoundary as o}from"react-error-boundary";import{jsx as n}from"react/jsx-runtime";function e({children:e,onError:t}){const i=r((r,o)=>{t(r instanceof Error?r:new Error(String(r),{cause:r}),o)},[t]);return n(o,{fallback:n("div",{style:{border:"1px solid #f00",color:"#f00",padding:"8px"},children:"An error was thrown."}),onError:i,children:e})}export{e as LexicalErrorBoundary};
